module.exports = __webpack_public_path__ + "static/media/semiconductors_video.922763b8.png";